import { render, staticRenderFns } from "./QuarterlySlideFactory.vue?vue&type=template&id=5ba72827&scoped=true&"
import script from "./QuarterlySlideFactory.vue?vue&type=script&lang=js&"
export * from "./QuarterlySlideFactory.vue?vue&type=script&lang=js&"
import style0 from "./QuarterlySlideFactory.vue?vue&type=style&index=0&id=5ba72827&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba72827",
  null
  
)

export default component.exports